import React from 'react'
import { Action, IOWidget, jsxToWidget, Pair } from 'widgets-for-react'
import { BlockData } from '../../../cms/blocks/types.gen'
import { ExtraImages } from '../../utils/extra_images.mod'

import { Block } from '../../../wordpress/types_and_parser/standard_blocks.gen'

import { MediaBlockProps, MediaBlockStyle } from '../../../cms/blocks/widgets/mediaBlock.gen'
import { TemplateState } from '../../../cms/page/types.gen'
import { CustomBlock } from '../../../wordpress/types_and_parser/custom_blocks.gen'
import { PublicSite_CustomPageData } from '../../application.mod'
import {
  bslArticleHighlightBlockClasses,
  bslCaseSliderBlockClasses,
  bslBeslismatrixFormBlockClasses,
  bslContactPersonBlockClasses,
  bslCountersBlockClasses,
  bslEventOverviewBlockClasses,
  bslFeaturedContentBlockClasses,
  bslLatestEventsBlockClasses,
  bslLatestVacanciesBlockClasses,
  bslQuoteBlockClasses,
  bslRichMediaBlockClasses,
  bslShowcaseBlockClasses,
  bslSuperGridBlockClasses,
  bslTabsBlockClasses,
  mediaBlockClasses,
  bslVacancySliderBlockClasses
} from '../style.mod'
import {
  BSLContactPersonBlock,
  BSLContactPersonBlockProps,
  BSLContactPersonBlockStyle
} from './widgets/bsl_contact_person'
import { BSLCountersBlock, BSLCountersBlockProps, BSLCountersBlockStyle } from './widgets/bsl_counters_block'
import {
  BSLFeaturedContentBlock,
  BSLFeaturedContentBlockProps,
  BSLFeaturedContentBlockStyle
} from './widgets/bsl_featured_content_block'
import { BSLHeaderBlock, BSLHeaderBlockProps, BSLHeaderBlockStyle } from './widgets/bsl_header'
import {
  BSLLatestVacanciesBlock,
  BSLLatestVacanciesBlockProps,
  BSLLatestVacanciesBlockStyle
} from './widgets/bsl_latest_vacancies'
import { BSLMediaBlock, BSLMediaBlockProps } from './widgets/bsl_media_block'
import { BSLQuoteBlock, BSLQuoteBlockProps, BSLQuoteBlockStyle } from './widgets/bsl_quote_block'
import { BSLRichMediaBlockProps, BSLRichMediaBlockStyle } from './widgets/bsl_richmedia_block'
import { BSLShowcaseBlock, BSLShowcaseBlockProps, BSLShowcaseBlockStyle } from './widgets/bsl_showcase'
import { BSLSuperGridBlock, BSLSuperGridBlockProps, BSLSuperGridBlockStyle } from './widgets/bsl_super_grid'
import { BSLTabsBlock, BSLTabsBlockProps, BSLTabsBlockStyle } from './widgets/bsl_tabs'
import { exampleBlock, exampleBlockProps, exampleBlockStyle } from './widgets/exampleBlock'
import {
  BSLVacancyOverviewBlock,
  BSLVacancyOverviewBlockProps,
  BSLVacancyOverviewBlockStyle,
} from './widgets/bsl_vacancy_overview'
import { BSLNewsOverviewBlockProps, BSLNewsOverviewBlockStyle, BSLNewsOverviewBlock } from './widgets/bsl_news_overview'
import {
  BSLLatestEventsBlockProps,
  BSLLatestEventsBlockStyle,
  BSLUpcomingEventsBlock
} from './widgets/bsl_latest_events'
import {
  BSLEventOverviewBlockProps,
  BSLEventOverviewBlock,
  BSLEventOverviewBlockStyle
} from './widgets/bsl_event_overview'
import { BSLCaseSliderBlock, BSLCaseSliderBlockProps, BSLCaseSliderBlockStyle } from './widgets/bsl_case_slider'

import {
  BSLArticleHighlightBlock,
  BSLArticleHighlightBlockProps,
  BSLArticleHighlightBlockStyle
} from './widgets/bsl_article_highlight';
import {
  BSLBeslismatrixFormBlock,
  BSLBeslismatrixFormBlockProps,
  BSLBeslismatrixFormBlockStyle
} from './widgets/bsl_beslismatrix_form'
import { 
  BSLVacancySliderBlock, 
  BSLVacancySliderBlockProps, 
  BSLVacancySliderBlockStyle 
} from './widgets/bsl_vacancy_slider'

export type exampleBlock = { kind: 'exampleBlock'; value: Pair<exampleBlockProps, exampleBlockStyle> }
export type BSLQuoteBlockData = {
  kind: 'quote_block'
  value: Pair<BSLQuoteBlockProps, BSLQuoteBlockStyle>
}
export type BSLSuperGridBlockData = {
  kind: 'super_grid'
  value: Pair<BSLSuperGridBlockProps<CustomBlockData, ExtraImages>, BSLSuperGridBlockStyle>
}
export type BSLTabsBlockData = {
  kind: 'tabs'
  value: Pair<BSLTabsBlockProps<CustomBlockData, ExtraImages>, BSLTabsBlockStyle>
}
export type BSLShowcaseBlockData = {
  kind: 'showcase'
  value: Pair<BSLShowcaseBlockProps<CustomBlockData, ExtraImages>, BSLShowcaseBlockStyle>
}
export type BSLLatestVacanciesBlockData = {
  kind: 'latest_vacancies'
  value: Pair<BSLLatestVacanciesBlockProps, BSLLatestVacanciesBlockStyle>
}
export type BSLContactPersonBlockData = {
  kind: 'contactperson'
  value: Pair<BSLContactPersonBlockProps<CustomBlockData, ExtraImages>, BSLContactPersonBlockStyle>
}
export type BSLFeaturedContentBlockData = {
  kind: 'featured_content_block'
  value: Pair<BSLFeaturedContentBlockProps<CustomBlockData, ExtraImages>, BSLFeaturedContentBlockStyle>
}
export type BSLCountersBlockData = {
  kind: 'counters'
  value: Pair<BSLCountersBlockProps, BSLCountersBlockStyle>
}
export type BSLMediaBlockData = {
  kind: 'media_block'
  value: Pair<BSLMediaBlockProps<ExtraImages>, MediaBlockStyle>
}
export type BSLRichMediaBlockData = {
  kind: 'bsl_richmedia'
  value: Pair<BSLRichMediaBlockProps, BSLRichMediaBlockStyle>
}
export type BSLHeaderBlockData = {
  kind: 'bsl_header'
  value: Pair<BSLHeaderBlockProps, BSLHeaderBlockStyle>
}
export type BSLNewsOverviewBlockData = {
  kind: 'news_overview'
  value: Pair<BSLNewsOverviewBlockProps, BSLNewsOverviewBlockStyle>
}
export type BSLVacancyOverviewBlockData = {
  kind: 'vacancy_overview'
  value: Pair<BSLVacancyOverviewBlockProps, BSLVacancyOverviewBlockStyle>
}
export type BSLLatestEventsBlockData = {
  kind: 'upcoming_events'
  value: Pair<BSLLatestEventsBlockProps, BSLLatestEventsBlockStyle>
}

export type BSLEventsOverviewBlockData = {
  kind: 'event_overview'
  value: Pair<BSLEventOverviewBlockProps, BSLEventOverviewBlockStyle>
}

export type BSLArticleHighlightBlockData = {
  kind:'highlight_article',
  value: Pair<BSLArticleHighlightBlockProps<ExtraImages>, BSLArticleHighlightBlockStyle>
}


export type BSLCaseSliderBlockData = {
  kind: 'case_slider'
  value: Pair<BSLCaseSliderBlockProps<ExtraImages>, BSLCaseSliderBlockStyle>
}

export type BSLVacancySliderBlockData = {
  kind: 'vacancy_slider'
  value: Pair<BSLVacancySliderBlockProps<ExtraImages>, BSLVacancySliderBlockStyle>
}

export type BSLBeslismatrixFormBlockData = {
  kind: 'beslismatrix_form'
  value: Pair<BSLBeslismatrixFormBlockProps, BSLBeslismatrixFormBlockStyle>
}

export type CustomBlockData =
  | BSLQuoteBlockData
  | BSLFeaturedContentBlockData
  | BSLCountersBlockData
  | BSLMediaBlockData
  | BSLRichMediaBlockData
  | BSLHeaderBlockData
  | BSLSuperGridBlockData
  | BSLContactPersonBlockData
  | BSLTabsBlockData
  | BSLShowcaseBlockData
  | BSLLatestVacanciesBlockData
  | BSLNewsOverviewBlockData
  | BSLVacancyOverviewBlockData
  | BSLLatestEventsBlockData
  | BSLEventsOverviewBlockData
  | BSLArticleHighlightBlockData
  | BSLCaseSliderBlockData
  | BSLBeslismatrixFormBlockData
  | BSLVacancySliderBlockData

export function isCustomBlockData<s, i>(b: BlockData<s, i> | CustomBlockData): b is CustomBlockData {
  return (
    b.kind === 'quote_block' ||
    b.kind === 'featured_content_block' ||
    b.kind === 'counters' ||
    b.kind === 'media_block' ||
    b.kind === 'bsl_richmedia' ||
    b.kind === 'bsl_header' ||
    b.kind === 'super_grid' ||
    b.kind === 'contactperson' ||
    b.kind === 'tabs' ||
    b.kind === 'showcase' ||
    b.kind === 'latest_vacancies' ||
    b.kind === 'vacancy_overview' ||
    b.kind === 'news_overview' ||
    b.kind === 'upcoming_events' ||
    b.kind === 'event_overview' ||
    b.kind === 'highlight_article' ||
    b.kind === 'case_slider'||
    b.kind === 'beslismatrix_form' ||
    b.kind === 'vacancy_slider'
  )
}

export function isCustomBlock<s, i>(b: Block | CustomBlock): b is CustomBlock {
  return (
    b.kind === 'quote_block' ||
    b.kind === 'featured_content_block' ||
    b.kind === 'counters' ||
    b.kind === 'media_block' ||
    b.kind === 'bsl_richmedia' ||
    b.kind === 'bsl_header' ||
    b.kind === 'super_grid' ||
    b.kind === 'contactperson' ||
    b.kind === 'tabs' ||
    b.kind === 'showcase' ||
    b.kind === 'latest_vacancies' ||
    b.kind === 'vacancy_overview' ||
    b.kind === 'news_overview' ||
    b.kind === 'upcoming_events' ||
    b.kind === 'event_overview' ||
    b.kind === 'highlight_article' ||
    b.kind === 'case_slider' ||
    b.kind === 'beslismatrix_form' ||
    b.kind === 'vacancy_slider'
  )
}

export function renderCustomBlock(
  block: CustomBlockData,
  key?: string
): IOWidget<
  TemplateState<CustomBlockData, CustomBlock, Block, ExtraImages, PublicSite_CustomPageData>,
  Action<TemplateState<CustomBlockData, CustomBlock, Block, ExtraImages, PublicSite_CustomPageData>>
> {
  return s0 => {
    if (block.kind === 'bsl_header') {
      return BSLHeaderBlock<CustomBlockData, any>(block.value.fst, { key, style: {} })(s0)
    }

    if (block.kind === 'media_block') {
      return BSLMediaBlock<CustomBlockData, any>(block.value.fst, {
        key,
        style: mediaBlockClasses(block.value.fst.kind_media)
      })(s0)
    }

    if (block.kind === 'quote_block') {
      return BSLQuoteBlock<CustomBlockData, any>(block.value.fst, { key, style: bslQuoteBlockClasses })(s0)
    }

    if (block.kind === 'tabs') {
      return BSLTabsBlock<CustomBlockData, any>(block.value.fst, { key, style: bslTabsBlockClasses })(s0)
    }

    if (block.kind === 'super_grid') {
      return BSLSuperGridBlock<CustomBlockData, any>(block.value.fst, { key, style: bslSuperGridBlockClasses })(s0)
    }

    if (block.kind === 'showcase') {
      return BSLShowcaseBlock<CustomBlockData, any>(block.value.fst, {
        key,
        style: bslShowcaseBlockClasses(block.value.fst.items.length)
      })(s0)
    }

    if (block.kind === 'contactperson') {
      return BSLContactPersonBlock<CustomBlockData, any>(block.value.fst, { key, style: bslContactPersonBlockClasses })(
        s0
      )
    }

    if (block.kind === 'featured_content_block') {
      return BSLFeaturedContentBlock<CustomBlockData, any>(block.value.fst, {
        key,
        style: bslFeaturedContentBlockClasses(block.value.fst.imageLocation)
      })(s0)
    }

    if (block.kind === 'counters') {
      return BSLCountersBlock<CustomBlockData, any>(block.value.fst, {
        key,
        style: bslCountersBlockClasses(block.value.fst.items.length)
      })(s0)
    }

    if (block.kind === 'latest_vacancies') {
      return BSLLatestVacanciesBlock<CustomBlockData, any>(block.value.fst, {
        key,
        style: bslLatestVacanciesBlockClasses
      })(s0)
    }

    if (block.kind === 'vacancy_overview') {
      return BSLVacancyOverviewBlock<CustomBlockData, any>(block.value.fst, {
        key,
        style: bslLatestVacanciesBlockClasses
      })(s0)
    }

    if (block.kind === 'news_overview') {
      return BSLNewsOverviewBlock<CustomBlockData, any>(block.value.fst, {
        key,
        style: bslLatestVacanciesBlockClasses
      })(s0)
    }

    if (block.kind === 'upcoming_events') {
      return BSLUpcomingEventsBlock<CustomBlockData, any>(block.value.fst, { key, style: bslLatestEventsBlockClasses })(
        s0
      )
    }

    if (block.kind === 'event_overview') {
      return BSLEventOverviewBlock<CustomBlockData, any>(block.value.fst, { key, style: bslEventOverviewBlockClasses })(
        s0
      )
    }

    
    if (block.kind === 'highlight_article') {
      return BSLArticleHighlightBlock<CustomBlockData, any>(block.value.fst, { key, style: bslArticleHighlightBlockClasses })(
        s0
      )
    }

    if (block.kind === 'case_slider') {
      return BSLCaseSliderBlock<ExtraImages>(block.value.fst, { key, style: 
        bslCaseSliderBlockClasses })(
          s0
        )
    }

    if (block.kind === 'vacancy_slider') {
      return BSLVacancySliderBlock<ExtraImages>(block.value.fst, { key, style: 
        bslVacancySliderBlockClasses })(
          s0
        )
    }
    
    if (block.kind === 'beslismatrix_form') {
      return BSLBeslismatrixFormBlock<CustomBlockData, any>(block.value.fst, {
        key,
        style: bslBeslismatrixFormBlockClasses
      })(
        s0
      )
    }

    return jsxToWidget(<div key={key}>Custom Block not found</div>).never()
  }
}
